import styled, { css } from "styled-components";

import { colors, globalStyle } from "global/globalStyle";

interface IBaseCardContainer {
  selected?: boolean;
  height?: number;
  disabled?: boolean;
}
export const Container = styled.div<IBaseCardContainer>`
  display: flex;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: space-between;
  flex-direction: row;

  ${(props) =>
    props.disabled &&
    css`
      opacity: 0.6;
      cursor: default;
      z-index: -1;
    `}
`;

export const LeftSide = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  img {
    margin-right: 12px;
  }
`;

export const TitleColumn = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
`;

export const RightContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 40px;
  strong {
    font-family: ${globalStyle.fontFamily};
    font-weight: 400;
    color: ${colors.default_label};
    font-size: 12px;
    line-height: 14.52px;

    @media screen and (max-width: 580px) {
      display: none;
    }
  }

  #status_badge {
    @media screen and (max-width: 475px) {
      display: none;
    }
  }
`;

export const DurationContainer = styled.div`
  padding: 3px 10px;
  border-radius: 7px;
  background: ${colors.neutral_black};
`;

export const DurationText = styled.label`
  font-size: 12px;
  color: ${colors.default_base_white};
  font-family: ${globalStyle.fontFamily};
  font-weight: 700;
`;
